/**
 * Array of available user roles in the system.
 * Each role is represented by an object with a value and label.
 */
export const ROLES = [
  { value: "gerente", label: "Gerente" },
  { value: "asistente", label: "Asesor de ventas" },
];

/**
 * Object containing error messages used in the user creation process.
 * These messages are used to provide feedback to the user during different scenarios.
 */
export const ERROR_MESSAGES = {
  /** Message displayed when the user attempts to cancel the creation process */
  cancelCreation:
    "¿Estás seguro que deseas cancelar la creación? Los cambios sin guardar no sufrirán efecto.",

  /** Success message displayed when a user is successfully created */
  userCreated: "El usuario ha sido creado exitosamente.",

  /** Error message displayed when there's a problem creating a user */
  createUserError: "Error al crear el usuario. Inténtalo más tarde.",

  /** Error message displayed when there's a problem updating a user */
  updateUserError: "Error al actualizar el usuario. Inténtalo más tarde.",

  /** Error message displayed when there's an email conflict during user creation */
  emailHasAlreadyUsed:
    "Este correo ya está en uso. Por favor, utiliza otro correo.",
};
